import { AsyncOperationsModel } from "../../../../utility/AsyncOperationsModel";
import BaseComponent from "../../../../utility/BaseComponent";
import { observable, action, computed } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
// import { DatePicker, TimePicker, 
//     TextField, Card, CardText, DialogContainer, Toolbar, Button, Paper, 
//     Radio, Checkbox, SelectField } from "react-md";
import { TextField, Card, CardText, DialogContainer, Toolbar, Button, Paper, Radio, Checkbox } from "react-md";
import "./static/AddSurveyDialog.scss";
import { IOrganisation, OrganisationSurvey, IUser } from "../../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { OrganisationSurveysOperations }
from "../../../../utility/admin/OrganisationOperations/OrganisationSurveysOperations/OrganisationSurveysOperations";
import { Scheduler } from "rxjs";
import { zip } from "rxjs/operators";
import * as moment from 'moment';

export class AddSurveyDialogModel extends AsyncOperationsModel {
    @observable user: IUser;
    @observable showDialog: boolean = false;
    @observable pageX: number = 0;
    @observable pageY: number = 0;
    @observable withSelectedRole: boolean = false;
    onComplete: Function;
    @observable surveyName = "";
    @observable surveyLink = "";
    @observable selectedRoles: string [] = [];
    @observable organisation: IOrganisation;
    @observable addDisabled: boolean = false;
    @observable onCreateClicked: Function;

    private operations: OrganisationSurveysOperations;
    // private subscriptions: Subscription;
    @action.bound
    setDialogVisible(flag: boolean) {
        this.showDialog = flag;
    }
    @action.bound
    setPageX(x: number) {
        this.pageX = x;
    }

    @action.bound
    setPageY(y: number) {
        this.pageY = y;
    }
    @action.bound
    resetAsyncOperationsCount() {
        this.asyncOperationsCount = 0;
    }
    @action.bound
    setOrganisation(organisation: IOrganisation) {
        this.organisation = organisation;
        this.resetAsyncOperationsCount();
    }
    @action.bound
    setUser(user: IUser) {
        this.user = user;
    }
    @computed get roles() {
        return this.organisation.roles;
    }
    @computed get groups() {
        return this.organisation.groups;
    }
    @action.bound 
    onRoleSelected(value: string) {
        if (!isNullOrUndefined(this.selectedRoles)) {
            let selectedRoleIndex = this.selectedRoles.findIndex(role => role === value);
            if (selectedRoleIndex > -1) {
                this.selectedRoles.splice(selectedRoleIndex, 1);
            } else {
                this.selectedRoles.push(value);
            }
        }
    }
    @action.bound
    onAudienceSelected(value: string) {
        if (value === "everyone") {
            this.withSelectedRole = false;
            this.selectedRoles = [];
        } else if (value === "roles") {
            this.withSelectedRole = true;
        }
    }
    @action.bound
    onDoneClicked() {
            this.setErrorMessages([]);
            if (this.withSelectedRole && this.selectedRoles.length < 1 ) {
            this.setErrorMessages(["You must select a role"]);
            return;
        }
            let regex = new RegExp("^(https?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?)" +
             "{1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (!regex.test(this.surveyLink)) {
                this.setErrorMessages(["The survey URL is invalid ( it must start with https://"]);
                return;
            }
            if (!isNullOrUndefined(this.surveyName) && this.surveyName.length !== 0) {
            let newSurvey: OrganisationSurvey = {
                id: null,
                username: this.user.username,
                roles: !isNullOrUndefined(this.selectedRoles) ? this.selectedRoles : [],
                name: this.surveyName,
                link: this.surveyLink,
                created_time: moment().toISOString(),
            };
            this.operations.addNewSurvey(newSurvey)
            .subscribe(
                result => {
                    this.onComplete(newSurvey);
                },
                error => {
                    this.addDisabled = false;
                    this.setErrorMessages(error.toString());
                    this.reportError(error);
                }
            );
        }
    }
    constructor(operations: OrganisationSurveysOperations) {
        super();
        this.asyncOperationsCount = 0;
        this.operations = operations;
    }
    @action.bound
    prepare() {
        this.asyncOperationsCount = 1;
        this.operations.observeOrganisationChanges()
        .pipe(zip((organisation) => {
                    this.setOrganisation(organisation);
                    return true;
                }))
            .subscribeOn(Scheduler.async)
            .observeOn(Scheduler.async)
            .subscribe(
                undefined,
                error => {
                    this.setErrorMessages(["Failed to fetch organisation information"]);
                    this.resetAsyncOperationsCount();
                    this.reportError(error);
                }
            );
    }

}

@observer class AddSurveyDialog extends BaseComponent<{model: AddSurveyDialogModel}, {}> {
    render() {
        return(
            <div>
            {
                !isNullOrUndefined(this.props.model) &&
                <DialogContainer
                    id="simple-full-page-dialog"
                    visible={this.props.model.showDialog}
                    pageX={this.props.model.pageX}
                    pageY={this.props.model.pageY}
                    fullPage={true}
                    onHide={() => {this.props.model.onComplete(undefined); }}
                    aria-labelledby="simple-full-page-dialog-title"
                >
                <Toolbar
                    fixed={true}
                    colored={true}
                    title="New Survey Info"
                    titleId="simple-full-page-dialog-title"
                    nav={<Button icon={true} onClick={() => {this.props.model.onComplete(undefined); }}>close</Button>}
                />
                {
                    !isNullOrUndefined(this.props.model.organisation) &&
                    
                <section className="md-toolbar-relative">
                    <div className="CreateNotificationPaperContainer">
                        {
                            this.props.model.errorMessages.length > 0 &&
                            <Card className="messagesCard">
                                <CardText className="messageText">
                                    {
                                        this.props.model.errorMessages.map(
                                            (item, index) => {
                                                return <p key={index}>{item}</p>;
                                            }
                                        )
                                    }
                                </CardText>
                            </Card>

                        }
                        <h5> 1. Recipients </h5>
                        <Paper
                            className="CreateNotificationPaper"
                            zDepth={2}
                            raiseOnHover={false}
                        >
                            <p>
                                <b> It will take up 24 hours before this survey becomes visible on user devices </b>
                            </p>
                        <p>
                        The survey will be visible by  users who meet the following criteria:
                        </p>
                        <div className="NotificationItemContainer">
                            <h5>Audience</h5>
                            <div className="ItemSubContainer">
                            <Radio 
                                id="everyone" 
                                name="everyone" 
                                label="Everyone" 
                                value="everyone"
                                onClick={() => this.props.model.onAudienceSelected("everyone")} 
                                checked={!this.props.model.withSelectedRole}
                            />

                            {
                                !isNullOrUndefined(this.props.model.roles) &&
                                this.props.model.roles.length > 0 &&
                                <Radio 
                                    id="roles" 
                                    name="roles" 
                                    value="roles"
                                    label="Selected Roles" 
                                    onClick={() => this.props.model.onAudienceSelected("roles")} 
                                    checked={this.props.model.withSelectedRole} 
                                />
                            }
                            </div>
                            <div className="RecipientsHiddenContainer">
                            {
                                this.props.model.withSelectedRole &&
                                <div>
                                    <h5>Roles</h5>
                                    <div className="ItemSubContainer">
                                    {
                                        this.props.model.roles.map(
                                            (role, index) => {
                                                return (
                                                    <Checkbox
                                                        key={index}
                                                        id={role.name}
                                                        name={role.name}
                                                        value={role.name}
                                                        label={role.name}
                                                        checked={!isNullOrUndefined(this.props.model.selectedRoles)
                                                            && this.props.model.selectedRoles
                                                            .findIndex(roleName => roleName === role.name) !== -1}
                                                        onChange={(e) => {this.props.model.onRoleSelected(role.name); }}
                                                    />
                                                );
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                            }
                            </div>
                        </div>

                        </Paper>
                    </div>

                    <div className="CreateNotificationPaperContainer">
                    <h5> 2. Survey Name </h5>

                    <Paper
                        className="CreateNotificationPaper"
                        zDepth={2}
                        raiseOnHover={false}
                    >
                    <p>
                        Give the survey a name in order to make it distinguishable.
                        The survey link is the URL to a survey created in third party tool (i.e. Survey Monkey) that
                        will be presented to the user of the app int the Surveys Management section
                    </p>

                    <TextField
                        id="floating-label-counter-field"
                        label="Survey Name"
                        required={true}
                        errorText="This field is required"
                        placeholder=""
                        maxLength={40}
                        className="md-cell md-cell--bottom"
                        // tslint:disable-next-line:max-line-length
                        helpText="Survey Name (up to 40 characters)"
                        value={this.props.model.surveyName}
                        onChange={ (value) => {
                            this.props.model.surveyName = value.toString();
                        } }
                    />
                    <TextField
                        id="multiline-counter-field"
                        label="Survey URL link"
                        // tslint:disable-next-line:max-line-length
                        helpText="Survey URL link"
                        required={true}
                        placeholder=""
                        rows={1}
                        type="url"
                        maxLength={200}
                        errorText="This field is required"
                        className="md-cell md-cell--bottom"
                        value={this.props.model.surveyLink}
                        onChange={ (value) => {
                            this.props.model.surveyLink = value.toString();
                        } }
                    />
                    </Paper>
                    </div>
                    <div className="NotificationSubmitContainer">
                        <Button 
                            flat={true}
                            secondary={true}
                            swapTheming={true} 
                            disabled={this.props.model.addDisabled}
                            onClick={this.props.model.onDoneClicked}
                            className='NotificationSubmit'
                        >
                        Add New Survey
                        </Button>
                        {
                            this.props.model.errorMessages.length > 0 &&
                            <Card className="messagesCard">
                                <CardText className="messageText">
                                    {
                                        this.props.model.errorMessages.map(
                                            (item, index) => {
                                                return <p key={index}>{item}</p>;
                                            }
                                        )
                                    }
                                </CardText>
                            </Card>
                        }                
                    </div>
                </section>
                
                }
                
                </DialogContainer>
            }
            </div>
        );
    }
}

export default AddSurveyDialog;


// WEBPACK FOOTER //
// ./src/view/Admin/OrganisationSurveys/AddSurveyDialog/AddSurveyDialog.tsx